<template>
    <v-dialog v-model="dialog" width="600">
        <v-card>
            <v-card-title class="headline">
                Zmień ilość
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="newForm"
                    v-model="valid"
                    lazy-validation
                    class="dimension--form mt-5 mb-5"
                >
                    <v-row>
                        <v-col cols="12" md="12" align-self="start" dense>
                            <v-text-field
                                v-model="data.quantity"
                                :rules="formRules.quantity"
                                class="pt-0"
                                label="Ilość"
                            >
                                <span
                                    slot="append"
                                >
                                    {{ this.order.service.unit}}
                                </span>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click.prevent="onSubmit"
                            type="Submit"
                            class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                            large
                        >Zmień<v-icon size="24">mdi-send</v-icon>
                        </v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
    name: 'ModalSetQuantity',
    props: {
        order: {},
    },
    created() {
    },
    data() {
        return {
            dialog: false,
            formRules: {
                quantity: [(value) => !!value || 'Uzupełnij ilość'],
            },
            valid: false,
            data: {
                quantity: 0,
            },
        }
    },
    methods: {
        open() {
            this.dialog = true;

          console.log(this.order.additionalData);
            this.data.quantity = this.order.additionalData['Ilość'];
        },
        async onSubmit() {
            if (!this.$refs.newForm.validate()) {
                return
            }

            api
                .put(`/api/orders/${this.order.id}`, {
                    quantity: this.data.quantity
                })
                .then(() => {
                    this.$root.$emit('notifySuccess', {
                        html: 'Zmieniono cenę.',
                    });
                    this.dialog = false;
                    this.$parent.loadDetails();
                })
                .catch((error) => {
                    console.error('Error when editing a redirect:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd podczas zmiany ilości',
                    });
                })
        },
    },
}
</script>

<style scoped></style>
